import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Logo from "../../../../../assets/images/Veeransh logo.png";

const MenuHeaderWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexShrink: 0,
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3.5, 2, 2.5),
  transition: "padding .25s ease-in-out",
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  position: "relative",
  zIndex: 3,
}));

const BrandStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  textDecoration: "none",
  width: "100%",
});

const VerticalNavHeader = (props) => {
  const {
    navHover,
    settings,
    collapsedNavWidth,
    navigationBorderWidth,
    verticalNavMenuBranding: userVerticalNavMenuBranding,
  } = props;

  const { navCollapsed } = settings;
  const collapsed = navCollapsed && !navHover;

  const menuHeaderPaddingLeft = () => {
    if (collapsed) {
      if (userVerticalNavMenuBranding) {
        return 0;
      }
      return (collapsedNavWidth - navigationBorderWidth - 30) / 8;
    }
    return 0;
  };

  return (
    <MenuHeaderWrapper
      className="nav-header"
      sx={{
        pl: menuHeaderPaddingLeft(),
        pr: collapsed ? menuHeaderPaddingLeft() : undefined,
        py: collapsed ? 2 : 3,
      }}
    >
      {userVerticalNavMenuBranding ? (
        userVerticalNavMenuBranding(props)
      ) : (
        <NavLink
          to="/dashboard"
          style={{ textDecoration: "none", width: "100%", display: "block" }}
        >
          <BrandStack>
            <Box
              component="img"
              src={Logo}
              alt="Veeransh Chemicals"
              sx={{
                height: collapsed ? 52 : 80,
                width: "auto",
                maxWidth: collapsed ? 60 : 200,
                objectFit: "contain",
                display: "block",
                mb: collapsed ? 0 : 2,
              }}
            />
            {!collapsed ? (
              <>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: "text.primary",
                    lineHeight: 1.3,
                    letterSpacing: "-0.02em",
                    fontSize: "0.9375rem",
                  }}
                >
                  Veeransh Admin
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    mt: 0.25,
                    lineHeight: 1.4,
                    fontSize: "0.75rem",
                  }}
                >
                  CMS &amp; operations
                </Typography>
              </>
            ) : null}
          </BrandStack>
        </NavLink>
      )}
    </MenuHeaderWrapper>
  );
};

export default VerticalNavHeader;
